// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import OffersTable from "./OffersTable";
import OfferCreateOrEdit from "./OfferCreateOrEdit";

// MARK: Router
import { Route, Switch } from "react-router-dom";

// MARK: Stores
import AuthStore from "../../../stores/AuthStore";

interface IProps {
	authStore: AuthStore;
}

@inject("authStore")
@observer
export default class Offers extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.authStore.authenticate();
	};

	public render() {
		return (
			<div className="offers">
				<Switch>
					<Route exact={true} path="/dashboard/offers/editor" component={OfferCreateOrEdit} />
					<Route path="/dashboard/offers/editor/:offerId" component={OfferCreateOrEdit} />
					<Route path="/dashboard/offers" component={OffersTable} />
				</Switch>
			</div>
		);
	}
}
